import DataGrid, { Column, Scrolling } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react'
import { GetReturnSalesProductData } from '../services/return-sales-service';

interface ShowProductModalProp {
    selectedId: string;
}

const ShowProductModal: React.FC<ShowProductModalProp> = ({ selectedId }) => {
    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'materialTypeId',
            load: async () => {
                try {
                    const response = await GetReturnSalesProductData(selectedId);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    return (
        <>
            <DataGrid
                dataSource={dataSource()}
                remoteOperations={{ groupPaging: true }}
                showRowLines={true}
                keyExpr="id"
                showBorders={true}
                columnAutoWidth={true}
                columnHidingEnabled={false}
            >
                <Scrolling
                    mode="standard"
                    useNative={true}
                    scrollByContent={true}
                    scrollByThumb={true}
                />
                <Column dataField="styleNo" caption="Style No" dataType="string" />
                <Column dataField="categoryName" caption="Category" dataType="string" />
                <Column dataField="materialTypeName" caption="Metal Type" dataType="string" />
                <Column dataField="netWt" format="#,##0.000" caption="Net Weight" dataType="number" />
                <Column dataField="actualNetWt" format="#,##0.000" caption="Act Net Wt" dataType="number" />
                <Column dataField="karatName" caption="Metal Kt" dataType="string" />
                <Column dataField="certificateNo" caption="IGI No." dataType="string" />
                <Column dataField="invoiceNo" caption="Invoice No." dataType="string" />
                <Column dataField="finalSaleOrderPrice" format="#,##0.00" caption="Selling Price" dataType="number" />
                <Column dataField="finalReturnSaleOrderPrice" format="#,##0.00" caption="Return Amt" dataType="number" />
            </DataGrid>
        </>
    )
}

export default ShowProductModal
